import Grid2 from '@mui/material/Unstable_Grid2'; // Grid version 2
import { useEffect, useState } from 'react';
import useQueryProvider from '../../../aegeon/query/useQueryProvider';

import { useGetList, useRecordContext } from 'react-admin';
import SiteMissingInformationDetailsContentLeft from './SiteMissingInformationDetailsContentLeft';
import SiteMissingInformationDetailsContentLeftBottom from './SiteMissingInformationDetailsContentLeftBottom';
import SiteMissingInformationDetailsContentRight from './SiteMissingInformationDetailsContentRight';
import SiteMissingInformationDetailsContentRightBottom from './SiteMissingInformationDetailsContentRightBottom';

const SiteMissingInformationDetailsContent = (props) => {
  const record = useRecordContext();
  const siteId = record?.id;
  const { data } = useGetList(
    'devices',
    {
      filter: {
        siteIds: { contains: siteId },
      },
    }
  );
  const devices_contracts_ids = data?.filter(device => device?.deviceType === "enedisMeter" || device?.deviceType === "grdfMeter")?.map(device => device?.id);
  const [deviceContracts, setDeviceContracts] = useState({});
  const [devicesData, setDevicesData] = useState(null);

  const DeviceContractsFetcher = ({ deviceId, onContractsFetched, deviceContracts }) => {
    const { data, isLoading } = useQueryProvider('devices', {
      query_name: "getDeviceContract",
      id: deviceId,
    });

    useEffect(() => {
      if (!isLoading && onContractsFetched && !deviceContracts[deviceId]) {
        if (data?.donneesGenerales?.etatContractuel?.libelle) {
          onContractsFetched(data?.donneesGenerales?.etatContractuel?.libelle);
        }
        else if (data?.permissions?.etat_droit_acces) {
          onContractsFetched(data?.permissions?.etat_droit_acces);
        }
        else {
          onContractsFetched("");
        }
      }
    }, [data, isLoading, onContractsFetched]);

    return null;
  };

  useEffect(() => {
    if (data && devices_contracts_ids?.length > 0 && (Object.keys(deviceContracts)?.length === devices_contracts_ids?.length) && !devicesData) {
      setDevicesData(data.map(device => {
        if (device?.deviceType === "enedisMeter" || device?.deviceType === "grdfMeter") {
          return { ...device, contract: deviceContracts[device?.id] || "" };
        }
        return device;
      }));
    }
  }, [data, devices_contracts_ids, deviceContracts, devicesData]);

  return (<div>
    <Grid2 container spacing={2}>
      {(deviceContracts?.length !== devices_contracts_ids?.length) &&
        devices_contracts_ids?.map((id, index) => (
          <DeviceContractsFetcher
            deviceContracts={deviceContracts}
            deviceId={id}
            key={index}
            onContractsFetched={(contract) => {
              if (!Object.keys(deviceContracts).includes(id)) {
                setDeviceContracts((prevContracts) => ({ ...prevContracts, [id]: contract }));
              }
            }}
          />
        ))
      }
      <Grid2 item="true" small={12} medium={12} big={6}>
        <SiteMissingInformationDetailsContentLeft />
      </Grid2>
      <Grid2 item="true" small={12} medium={12} big={6}>
        <SiteMissingInformationDetailsContentRight devices={devicesData} />
      </Grid2>
      <Grid2 item="true" small={12} medium={12} big={6}>
        <SiteMissingInformationDetailsContentLeftBottom devices={devicesData} />
      </Grid2>
      <Grid2 item="true" small={12} medium={12} big={6}>
        <SiteMissingInformationDetailsContentRightBottom devices={devicesData} deviceContracts={deviceContracts} />
      </Grid2>
    </Grid2>
  </div>);
};

export default SiteMissingInformationDetailsContent;

